import React from 'react';

export function renderProductName(name: string): React.ReactNode {
  const match = name.match(/\s+(\d+(?:[,/]\d+)?(?:\s*(?:l|Flasche|Liter))?|Flasche|Liter)$/i);
  if (!match) return name;

  const volumeStart = match.index!;
  return (
    <>
      {name.slice(0, volumeStart)}
      {' '}
      <strong>{match[1]}</strong>
    </>
  );
}
